import * as duckActions from './actions'
import * as duckOperations from './operations'
import reducer from './reducers'
import * as duckType from './types'

export { duckOperations, duckActions, duckType }

export default reducer
